export const GET_DOMAINS_FOR_ENTITY_REQUEST = 'GET_DOMAINS_FOR_ENTITY_REQUEST';
export const GET_DOMAINS_FOR_ENTITY_REQUEST_SUCCESS =
  'GET_DOMAINS_FOR_ENTITY_REQUEST_SUCCESS';
export const GET_DOMAINS_FOR_ENTITY_REQUEST_ERROR =
  'GET_DOMAINS_FOR_ENTITY_REQUEST_ERROR';
